module.exports = fox._r("fonts/throughChat.woff?exnqbq", __webpack_public_path__ + "_/_/_/root/fonts/2iTfW7j.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/throughChat.woff?exnqbq
// module id = 430
// module chunks = 4